import type { Routes } from '@angular/router';
import { authGuard, creditsGuard } from '@sortaify/client-core';
import { uploadDirtyGuard } from './guards/upload-dirty.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/landing/landing.component').then((m) => m.LandingComponent),
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./pages/auth/register/register.component').then((m) => m.RegisterComponent),
      },
      {
        path: 'auth/callback',
        loadComponent: () =>
          import('./pages/auth/callback/callback.component').then((m) => m.CallbackComponent),
      },
      {
        path: 'verify-email',
        loadComponent: () =>
          import('./pages/auth/verify-email/verify-email.component').then((m) => m.VerifyEmailComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
      },
      {
        path: 'verify-reset-code',
        loadComponent: () =>
          import('./pages/auth/verify-reset-code/verify-reset-code.component').then((m) => m.VerifyResetCodeComponent),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
      },
      {
        path: 'dashboard/v2',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/dashboard/dashboard-v2.component').then((m) => m.DashboardV2Component),
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'upload',
        canActivate: [authGuard, creditsGuard],
        canDeactivate: [uploadDirtyGuard],
        loadComponent: () =>
          import('./pages/upload/upload.component').then((m) => m.UploadComponent),
      },
      {
        path: 'bulk-upload',
        redirectTo: 'upload',
      },
      {
        path: 'documents',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/documents/documents.component').then((m) => m.DocumentsComponent),
      },
      {
        path: 'pricing',
        loadComponent: () =>
          import('./pages/pricing/pricing.component').then((m) => m.PricingComponent),
      },
      {
        path: 'no-credits',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/no-credits/no-credits.component').then((m) => m.NoCreditsComponent),
      },
      {
        path: 'v2',
        loadComponent: () =>
          import('./pages/landing/landing-v2.component').then((m) => m.LandingV2Component),
      },
      {
        path: 'v3',
        loadComponent: () =>
          import('./pages/landing/landing-v3.component').then((m) => m.LandingV3Component),
      },
      {
        path: 'v4',
        loadComponent: () =>
          import('./pages/landing/landing-v4.component').then((m) => m.LandingV4Component),
      },
      {
        path: 'v5',
        loadComponent: () =>
          import('./pages/landing/landing-v5.component').then((m) => m.LandingV5Component),
      },
      {
        path: 'settings',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
      },
      {
        path: 'linked-accounts',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/linked-accounts/linked-accounts.component').then((m) => m.LinkedAccountsComponent),
      },
      {
        path: 'subscription',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./pages/billing/billing.component').then((m) => m.BillingComponent),
      },
      {
        path: 'product',
        loadComponent: () =>
          import('./pages/product/product.component').then((m) => m.ProductComponent),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./pages/legal/privacy.component').then((m) => m.PrivacyComponent),
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./pages/legal/terms.component').then((m) => m.TermsComponent),
      },
      {
        path: 'impressum',
        loadComponent: () =>
          import('./pages/legal/impressum.component').then((m) => m.ImpressumComponent),
      },
      {
        path: 'cookies',
        loadComponent: () =>
          import('./pages/legal/cookies.component').then((m) => m.CookiesComponent),
      }
    ]
  },
  { path: '**', redirectTo: '' },
];
